import * as React from 'react';
import { currentUrl, urlToString } from 'Shared/url';
import { nuke as nukeCache } from 'SiteLayout/CurrentPage/cache';
import { triggerEvent } from 'SiteLayout/Root';
const ERROR_PARAM_NAME = 'jserror';
class ErrorBoundaryInner extends React.Component {
    componentDidCatch() {
        this.forceUpdate(); // This will cause all children to be recreated and remounted
    }
    render() {
        return this.props.children;
    }
}
export default class ErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        if (!__DEV__) {
            const url = currentUrl();
            const match = (url.query[ERROR_PARAM_NAME] || '').match(/^[0-9]+$/);
            const errorState = match ? +match[0] : 0;
            switch (errorState) {
                case 0:
                    url.query[ERROR_PARAM_NAME] = '1';
                    window.location.replace(urlToString(url));
                    break;
                case 1:
                    nukeCache().then(() => {
                        url.query[ERROR_PARAM_NAME] = '2';
                        window.location.replace(urlToString(url));
                    });
                    break;
                default:
                    triggerEvent({ type: 'scope:fataljserror', error, info });
                    break;
            }
        }
    }
    render() {
        return React.createElement(ErrorBoundaryInner, null, this.props.children);
    }
}
